import React from 'react';
import { useTranslation } from 'react-i18next';
import { LI, UL, H5 } from '../../../../AbstractElements';

export const SocialLinks = () => {
  const handleClick = (e) => {
    e.preventDefault();
  };

  return (
    <UL attrUL={{horizontal:true, className: 'd-flex justify-content-center card-social' }}>
      <LI>
        <a href='#' onClick={handleClick}>
          <i className='fa fa-facebook' />
        </a>
      </LI>
      <LI>
        <a href='#' onClick={handleClick}>
          <i className='fa fa-google-plus' />
        </a>
      </LI>
      <LI>
        <a href='#' onClick={handleClick}>
          <i className='fa fa-twitter' />
        </a>
      </LI>
      <LI>
        <a href='#' onClick={handleClick}>
          <i className='fa fa-instagram' />
        </a>
      </LI>
      <LI>
        <a href='#' onClick={handleClick}>
          <i className='fa fa-rss' />
        </a>
      </LI>
    </UL>
  );
};

const UserStats = ({ totalPost, follower, following }) => {
  const { t } = useTranslation();
  
  return (
    <UL attrUL={{ className: 'social-follow' }}>
      <LI>
        <H5 attrH5={{ className: 'mb-0' }}>{totalPost}</H5>
        <span className='f-light'>{t('Profile_Articles')}</span>
      </LI>
      <LI>
        <H5 attrH5={{ className: 'mb-0' }}>{follower}</H5>
        <span className='f-light'>{t('Profile_Presentations')}</span>
      </LI>
      <LI>
        <H5 attrH5={{ className: 'mb-0' }}>{following}</H5>
        <span className='f-light'>{t('Profile_Reviews')}</span>
      </LI>
    </UL>
  );
};

export default UserStats;
